// related-products-scroll.js
(function () {
  if (window.__relInit) return;
  window.__relInit = true;

  function initSection(section) {
    if (!section || section.dataset.relDone === '1') return;

    const container = section.querySelector('.related-container');
    const leftBtn = section.querySelector('.scroll-btn-left');
    const rightBtn = section.querySelector('.scroll-btn-right');
    if (!(container && leftBtn && rightBtn)) return;

    section.dataset.relDone = '1';

    // Helpers
    const updateArrows = () => {
      const max = container.scrollWidth - container.clientWidth;
      const atStart = container.scrollLeft <= 1;
      const atEnd = container.scrollLeft >= max - 1;
      leftBtn.disabled = atStart || max <= 0;
      rightBtn.disabled = atEnd || max <= 0;
    };

    const scrollStep = 200;

    leftBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: scrollStep, behavior: 'smooth' });
    });

    container.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    // touch drag usor (optional)
    let down = false, startX = 0, startLeft = 0;
    container.addEventListener('touchstart', (e) => {
      down = true;
      startX = e.touches[0].pageX - container.offsetLeft;
      startLeft = container.scrollLeft;
    }, { passive: true });
    container.addEventListener('touchmove', (e) => {
      if (!down) return;
      e.preventDefault();
      const x = e.touches[0].pageX - container.offsetLeft;
      container.scrollLeft = startLeft - (x - startX) * 2;
    }, { passive: false });
    container.addEventListener('touchend', () => { down = false; });

    // init state (important!)
    requestAnimationFrame(updateArrows);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="related-products"]').forEach(initSection);
  }

  // 1) DOM gata
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 2) cand recomandările sunt randate asincron (Dawn emite evenimentul asta)
  document.addEventListener('product-recommendations:updated', (e) => {
    const sec = e.target.closest('[data-section-type="related-products"]');
    if (sec) {
      delete sec.dataset.relDone;
      initSection(sec);
    }
  });

  // 3) editor tema / re-injectari
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector?.('[data-section-type="related-products"]');
    if (sec) {
      delete sec.dataset.relDone;
      initSection(sec);
    }
  });
})();
